
import {
  computed, defineComponent, onMounted, ref, watch, onBeforeUnmount,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { descriptionWithLink } from '@/helpers/utils';
// eslint-disable-next-line import/no-cycle
import { useDriveStore } from '../store/driveStore';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
// eslint-disable-next-line import/no-cycle
import { CASE_VIEW_NAVIGATION, NAVIGATION_PAGES, PHOTO_VIEW_TYPE } from '@/types/enums';
import { IMedia, IPhoto } from '@/types/interfaces';
import { lowResUrlByViewTypeByUrl } from '@/helpers/lowResPhotoUrl';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';
import DriveMediaView from '@/modules/drive/components/desktop/mediaview/DriveMediaView.vue';
import AppMediaView from '@/components/AppMediaView/AppMediaView.vue';
import HeaderMainView from '@/components/BootstrapComponents/HeaderMainView.vue';
import HeaderDownloadApp from '@/components/BootstrapComponents/HeaderDownloadApp.vue';
import TagView from '@/components/BootstrapComponents/TagView.vue';
import NoPhotoVideo from '@/components/BootstrapComponents/NoPhotoVideo.vue';
import DescriptionView from '@/components/BootstrapComponents/DescriptionView.vue';
import FileListView from '@/components/BootstrapComponents/FileListView.vue';
import CaseCreaterView from '@/components/BootstrapComponents/CaseCreaterView.vue';
import OpenApplicationPanel from '@/components/BootstrapComponents/OpenApplicationPanel.vue';
import PhotoCarousel from '@/components/BootstrapComponents/PhotoCarousel.vue';

export default defineComponent({
  components: {
    DriveMediaView,
    AppMediaView,
    HeaderMainView,
    HeaderDownloadApp,
    TagView,
    NoPhotoVideo,
    DescriptionView,
    FileListView,
    CaseCreaterView,
    OpenApplicationPanel,
    PhotoCarousel,
  },
  emits: ['open-share'],
  props: {
    showSkeleton: { type: Boolean, default: false },
  },
  setup() {
    const driveStore = useDriveStore();
    const mainStore = useMainStore();
    const route = useRoute();
    const router = useRouter();

    const userToken = computed(() => localStorage.getItem('authToken'));
    const isDesktop = ref(window.innerWidth > 768);

    const isNetwork = computed(() => route.meta.isNetwork);
    const dataLoading = ref<boolean>(true);
    const currentSubpage = ref<CASE_VIEW_NAVIGATION>(CASE_VIEW_NAVIGATION.OVERVIEW);

    function selectPhoto(photo: IMedia): void {
      driveStore.appPhotoViewMedia = photo;
    }

    const isIOS = ref(/iPad|iPhone|iPod/.test(navigator.userAgent));

    function openApp() {
      if (window.navigator.userAgent.match(/CaseDrive.tst/i)) {
        // router.push(`${driveStore.currentCase.publicUrl}`);
        router.push('/messages/my');
      } else {
        window.location.href = isIOS.value ? (process.env.VUE_APP_IPHONE_URL || '') : (process.env.VUE_APP_ANDROID_URL || '');
      }
    }
    function selectVideo(video: IMedia): void {
      driveStore.appPhotoViewMedia = video;
    }

    function backAction(): void {
      router.back();
    }

    function resolvePhoto(item: {
      name: string;
      photo: IPhoto;
      isGroup: boolean;
    }): string {
      if (item.photo?.url) {
        return lowResUrlByViewTypeByUrl(item.photo.url, PHOTO_VIEW_TYPE.WHSML);
      }
      if (item.isGroup) {
        // eslint-disable-next-line global-require
        return require('@/assets/img/mockup/Group.svg');
      }
      // eslint-disable-next-line global-require
      return require('@/assets/img/mockup/profile.svg');
    }

    function fetchCase() {
      dataLoading.value = true;
      driveStore
        .getPublicCaseByUrl(route.params.publicUrl as string)
        .then((res) => {
          driveStore.currentCase = { ...res };
          driveStore.photoList = driveStore.currentCase.photos;
          // if (!myCase.value) {
          //   router.push(`/public/case/${driveStore.currentCase.publicUrl}/`);
          // }
        })
        .finally(() => {
          dataLoading.value = false;
        });
    }

    function closeFullScreen() {
      driveStore.appPhotoViewMedia = undefined;
      driveStore.fullscreenPhoto = undefined;
      driveStore.fullscreenFile = undefined;
    }

    watch(
      () => route.params.id,
      () => {
        if (route.params.id && route.meta.navigationPage === NAVIGATION_PAGES.CASE_VIEW) {
          fetchCase();
        }
      },
    );
    const handleResize = () => {
      isDesktop.value = window.innerWidth > 768;
    };

    onMounted(() => {
      MonitoringService.sendPageMountedSpeed();
      window.addEventListener('resize', handleResize);
      fetchCase();
    });

    onBeforeUnmount(() => {
      driveStore.resetCurrentCase();
      window.removeEventListener('resize', handleResize);
    });

    return {
      dataLoading,
      isNetwork,
      currentSubpage,
      driveStore,
      selectPhoto,
      resolvePhoto,
      selectVideo,
      CASE_VIEW_NAVIGATION,
      closeFullScreen,
      mainStore,
      userToken,
      openApp,
      backAction,
      isDesktop,
      descriptionWithLink,
    };
  },
});
